import {usePopup} from "@/components/layouts/popup/InfoPopup/PopupContext";
import {SuccessfulPassPopup} from "@/components/popups/attentionPopups/SuccessfulPassPopup";
import {FormError} from "@/components/ui/forms/FormError";
import {setError, updateUser} from "@/redux/slices/userSlices/editSlice";

import {useState} from "react";

import checkImage from "@images/popups/check.png";
import crossImage from "@images/popups/cross.png";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {Spinner} from "@ui/general/Spinner";
import {RootIcon} from "@ui/icons/RootIcon";
import {RootInput} from "@ui/inputs/RootInput";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

const PasswordInput = ({label, value, onChange, show, toggleShow}) => (
  <div className={styles.input}>
    <RootInput
      width={307}
      label={label}
      type={show ? "text" : "password"}
      value={value}
      required
      onChange={onChange}
      autoComplete={"new-password"}
    />
    <div onClick={toggleShow}>
      <RootIcon
        width={24}
        height={24}
        id={"show-pass"}
      />
    </div>
  </div>
);

export const ChangePassPopup = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {openPopup} = usePopup();

  const {id} = useSelector((state) => state.common.candidate);

  const [match, setMatch] = useState(true);
  const [passwords, setPasswords] = useState({
    newPassword: {input: "", show: false},
    repeatPassword: {input: "", show: false},
  });

  const {status} = useSelector((state) => state.user.edit);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMatch(passwords.newPassword.input === passwords.repeatPassword.input);

    if (match) {
      const user = {
        user: {
          password: passwords.newPassword.input,
          password_confirmation: passwords.repeatPassword.input,
        },
      };

      const resultAction = await dispatch(updateUser({id, user}));

      if (updateUser.fulfilled.match(resultAction)) {
        openPopup(<SuccessfulPassPopup />);
      } else {
        dispatch(setError(t("server_error.save_error")));
      }
    }
  };

  const toggleShowPassword = (field) => {
    setPasswords((prev) => ({
      ...prev,
      [field]: {...prev[field], show: !prev[field].show},
    }));
  };

  return (
    <div className={styles.changePass}>
      <H3>{t("popup.change_pass.title")}</H3>

      <form
        onSubmit={handleSubmit}
        className={styles.changePassForm}
      >
        <PasswordInput
          label={t("input.type_new_password")}
          value={passwords.newPassword.input}
          onChange={(e) =>
            setPasswords((prev) => ({
              ...prev,
              newPassword: {...prev.newPassword, input: e.target.value},
            }))
          }
          show={passwords.newPassword.show}
          toggleShow={() => toggleShowPassword("newPassword")}
        />

        <PasswordInput
          label={t("input.repeat_new_password")}
          value={passwords.repeatPassword.input}
          onChange={(e) =>
            setPasswords((prev) => ({
              ...prev,
              repeatPassword: {...prev.repeatPassword, input: e.target.value},
            }))
          }
          show={passwords.repeatPassword.show}
          toggleShow={() => toggleShowPassword("repeatPassword")}
        />

        {!match && (
          <FormError
            error={t("server_error.passwords_match")}
            bottom={65}
            center
          />
        )}

        <div className={styles.description}>
          <RootDesc>
            <b>{t("popup.change_pass.password_requirements")}</b>
          </RootDesc>

          <ul>
            <li>
              <img
                src={checkImage}
                alt={"icon"}
              />

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t("popup.change_pass.minimum_8_characters"),
                  }}
                />
              </RootDesc>
            </li>

            <li>
              <img
                src={crossImage}
                alt={"icon"}
              />

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "popup.change_pass.include_uppercase_and_lowercase",
                    ),
                  }}
                />
              </RootDesc>
            </li>

            <li>
              <img
                src={checkImage}
                alt={"icon"}
              />

              <RootDesc>
                <span
                  dangerouslySetInnerHTML={{
                    __html: t(
                      "popup.change_pass.include_number_or_special_character",
                    ),
                  }}
                />
              </RootDesc>
            </li>
          </ul>
        </div>

        <RootButton
          txt={t("button.save_new_password")}
          type={"submit"}
          disabled={
            !passwords.newPassword.input ||
            !passwords.repeatPassword.input ||
            status === "loading"
          }
        />

        {status === "loading" && (
          <Spinner
            width={50}
            height={50}
          />
        )}
      </form>
    </div>
  );
};
